import React, { PropsWithChildren, ReactNode } from "react";
import GamesBannerWebView from "@/components/webview/games/core/GamesBannerWebView";
import { FadeInSection } from "@/components/webview/games/core/FadeInSectionWebview";

export const LayoutGamesMainWebView = ({
  children,
  bannerContents,
  bannerImg,
}: PropsWithChildren<{
  bannerContents: ReactNode;
  bannerImg: string;
}>) => {
  return (
    <div>
      <section className="px-5 pb-[22px]">
        <GamesBannerWebView mobileImage={bannerImg}>
          <GamesBannerWebView.Image className="min-h-[240px] laptop:min-h-[480px]" />
          <GamesBannerWebView.Content>
            {bannerContents}
          </GamesBannerWebView.Content>
        </GamesBannerWebView>
      </section>
      {children}
    </div>
  );
};
